import React from "react";
import HeroSection from "./heroSection/herosection";
import AboutUS from "./aboutUs/aboutUs";
import AboutLogo from "./aboutLogo/aboutLogo";
import Programs from "./programs/programs";
import Activities from "./activities/activities";
import CallToAction from "./callToAction/callToAction";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";

function LandingPage() {
  return (
    <div className="overflow_page">
      <Navbar />
      <HeroSection />
      <AboutUS />
      <AboutLogo />
      <Programs />
      <Activities />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default LandingPage;
